<template>
    <div class="c-reviews__slider">
        <Swiper
            :modules="[SwiperGrid, SwiperNavigation]"
            :slides-per-view="1.5"
            :space-between="20"
            :speed="800"
            :observer="true"
            :observe-parents="true"
            :navigation="{
                nextEl: '.c__reviews__next',
                prevEl: '.c__reviews__prev'
            }"
            :class="['swiper-stretch', 'swiper-stretch-left']"
            :breakpoints="{
                768: {
                    slidesPerView: 3.5,
                    spaceBetween: 20
                },
                1181: {
                    slidesPerView: 4.3,
                    spaceBetween: 40
                }
            }"
            @resize="(e) => onSlideResize(e)"
        >
            <SwiperSlide v-for="review in reviews" :key="reviews.id">
                <CardsReview :review="review" />
            </SwiperSlide>
        </Swiper>
    </div>
</template>

<script setup>
    const props = defineProps({
        reviews: {
            type: Array,
            default: []
        }
    });

    const { $gsap: gsap } = useNuxtApp();

    const recalculateCardReviewContent = (slides) => {
        if (slides) {
            let maxHeight = 0;

            slides.forEach((element) => {
                const heading = element.querySelector(".card-review__heading");
                const title = element.querySelector(".card-review__title");
                const quote = element.querySelector(".card-review__quote");

                maxHeight = Math.max(maxHeight, heading.clientHeight + title.clientHeight + quote.clientHeight);
            });

            gsap.set(document.documentElement, {
                ["--review-height"]: `${maxHeight}px`
            });
        }
    };

    const onSlideResize = (event) => recalculateCardReviewContent(event.slides);
</script>
